import type { SlotConfig } from "#/components/dashboard/DashboardGrid.js";
import type { TemplateLayoutProps } from "#/lib/templates/types.js";
import { BentoSlotGrid } from "./templateData.js";

export const BENTO_CONSOLE_LAYOUT: SlotConfig[] = [
  { id: "kpi", span: { base: 12, xl: 4 }, htmlId: "kpis", ariaLabel: "Key indicators" },
  { id: "ticker", span: { base: 12, xl: 8 }, htmlId: "ticker" },
  { id: "map", span: { base: 12, lg: 8 }, htmlId: "map" },
  { id: "world-status", span: { base: 12, lg: 4 }, htmlId: "world-status-map" },
  { id: "vessel-track", span: { base: 12 }, htmlId: "vessel-live-track" },
  { id: "port-events", span: { base: 12, lg: 6 }, htmlId: "port-events" },
  { id: "regions", span: { base: 12, lg: 6 }, htmlId: "regions" },
  { id: "timeline", span: { base: 12 }, htmlId: "timeline" },
  { id: "passenger-silence", span: { base: 12, md: 6, xl: 4 }, htmlId: "passenger-silence" },
  { id: "communication-patterns", span: { base: 12, md: 6, xl: 4 } },
  { id: "contradictions", span: { base: 12, md: 6 }, htmlId: "contradictions" },
  { id: "unanswered-questions", span: { base: 12, md: 6 }, htmlId: "unanswered-questions" },
  { id: "news", span: { base: 12, md: 6 }, htmlId: "news", ariaLabel: "News" },
  { id: "faq", span: { base: 12, md: 6, xl: 3 }, htmlId: "faq", ariaLabel: "FAQ" },
  { id: "pathogen", span: { base: 12, md: 6, xl: 3 }, htmlId: "pathogen" },
  { id: "exposure-window", span: { base: 12, md: 6, xl: 4 }, htmlId: "exposure-window" },
  { id: "official-sources", span: { base: 12 }, htmlId: "official-sources" },
];

export function TemplateBentoConsole(props: TemplateLayoutProps) {
  return (
    <main id="main-content" data-template-layout="bento-console">
      <div className="mx-auto max-w-[96rem] px-4 py-4 sm:px-6 lg:px-8">
        <BentoSlotGrid props={props} layout={BENTO_CONSOLE_LAYOUT} className="gap-4 md:gap-6" />
      </div>
    </main>
  );
}
